var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectBalancingPackageById } from "../balancingSelectors/selectBalancingPackages";
import { selectPlayerProfileBalancing } from "../balancingSelectors/selectBalancingPictures";
import { getResourceIconInfo } from "../features/generic/icon/getResourceIconInfo";
import { mapActionButton } from "../features/hud-action-button/mapActionButton";
import { IdPendingInventoryRewardType } from "../features/pending-inventory/IdPendingInventoryRewardType";
import { mapPendingInventoryActionToInfo, } from "../features/pending-inventory/mapPendingInventoryActionToInfo";
import { mapPendingInventoryTypeToAction } from "../features/pending-inventory/mapPendingInventoryTypeToAction";
var sortByCreationTime = function (currentVal, nextVal) {
    return currentVal.creationTime - nextVal.creationTime;
};
export var selectPendingInventoryInfo = function (state) {
    return state.pendingInventoryInfo.pending || [];
};
export var selectPendingInventoryByActionButtonId = function (state, idActionButton) {
    var matchingElements = [];
    mapPendingInventoryTypeToAction.forEach(function (key, element) {
        if (key === idActionButton) {
            matchingElements.push(element);
        }
    });
    var potentialIds = matchingElements.filter(function (key) {
        return mapPendingInventoryTypeToAction.get(key) === idActionButton;
    });
    var pendingInventoryCandidates = state
        .pendingInventoryInfo.pending
        ? state.pendingInventoryInfo.pending.filter(function (element) {
            return potentialIds.indexOf(element.typeId) >= 0;
        })
        : undefined;
    return pendingInventoryCandidates === undefined
        ? undefined
        : selectHighestPriorityPendingInventoryInfo(state, pendingInventoryCandidates);
};
export var selectPendingInventoryTransferIdByTypeId = function (state, typeId) {
    var pendingInventoryItems = state.pendingInventoryInfo.pending;
    if (pendingInventoryItems) {
        var pendingInventoryItem = pendingInventoryItems.find(function (item) { return item.typeId === typeId; });
        return pendingInventoryItem ? pendingInventoryItem.transferId : undefined;
    }
    return;
};
export var selectHighestPriorityPendingInventoryInfo = function (state, pendingInventoryParams) {
    if (pendingInventoryParams === void 0) { pendingInventoryParams = undefined; }
    if (pendingInventoryParams === undefined) {
        pendingInventoryParams = state.pendingInventoryInfo.pending || [];
        if (!pendingInventoryParams || pendingInventoryParams.length === 0) {
            return undefined;
        }
    }
    // sort by creationTime
    pendingInventoryParams = pendingInventoryParams.sort(sortByCreationTime);
    var priority = 99;
    var result;
    pendingInventoryParams.forEach(function (entry) {
        var key = mapPendingInventoryTypeToAction.get(entry.typeId);
        if (key === undefined) {
            return;
        }
        var actionButtonInfo = mapActionButton.get(key);
        if (actionButtonInfo !== undefined) {
            if (result === undefined ||
                priority > actionButtonInfo.priority ||
                (priority === actionButtonInfo.priority &&
                    result.creationTime < entry.creationTime)) {
                priority = actionButtonInfo.priority;
                result = entry;
            }
        }
    });
    return result;
};
export var selectPendingInventoryCount = function (state) {
    return state.pendingInventoryInfo.pending ? state.pendingInventoryInfo.pending.length : 0;
};
export var selectPendingInventoryRewardsIconInfo = function (state, pendingInventoryInfo) {
    var latestPendingInventoryInfo = pendingInventoryInfo !== undefined
        ? pendingInventoryInfo
        : selectHighestPriorityPendingInventoryInfo(state);
    if (!latestPendingInventoryInfo) {
        return [];
    }
    var resource = latestPendingInventoryInfo.resource, building = latestPendingInventoryInfo.building, pkg = latestPendingInventoryInfo.package, picture = latestPendingInventoryInfo.picture;
    var resources = [];
    var concatResourceInfoToResources = function (itemParam, type) {
        resources = resources.concat(getResourceInfo(itemParam, type));
    };
    if (resource && resource.length > 0) {
        concatResourceInfoToResources(resource, IdPendingInventoryRewardType.Resource);
    }
    if (building && building.length > 0) {
        concatResourceInfoToResources(building, IdPendingInventoryRewardType.Building);
    }
    if (pkg && pkg.length > 0) {
        concatResourceInfoToResources(pkg, IdPendingInventoryRewardType.Package);
    }
    if (picture && picture.length > 0) {
        var profilePictures = picture.map(function (pic) {
            var pictureInfo = selectPlayerProfileBalancing(pic.typeId);
            return {
                amount: pic.amount || 1,
                icon: pictureInfo.assetName,
                type: IdPendingInventoryRewardType.Picture,
            };
        });
        resources = resources.concat(profilePictures);
    }
    return resources;
};
export var selectPendingInventoryActionInfo = function (typeId) {
    var inventoryAction = mapPendingInventoryTypeToAction.get(typeId);
    if (!inventoryAction) {
        return undefined;
    }
    return mapPendingInventoryActionToInfo.get(inventoryAction);
};
var getResourceInfo = function (resources, type) {
    if (type === IdPendingInventoryRewardType.Package) {
        return getResourceInfoFromPackageAsIItemParamArray(resources);
    }
    return resources.map(function (resource) {
        return __assign({}, getResourceIconInfo(resource), { type: type });
    });
};
var getResourceInfoFromPackageTypeField = function (pack, key, rewardType) {
    var field = pack[key];
    if (Array.isArray(field)) {
        return getResourceInfo((field || []).map(function (element) {
            return {
                amount: Long.fromValue(element.amount),
                stageId: 0,
                typeId: element.resourceId,
            };
        }), rewardType);
    }
    return [];
};
var getResourceInfoFromPackageAsIItemParamArray = function (resources) {
    return resources.reduce(function (accumulator, res) {
        if (res.typeId) {
            var foundPackage = selectBalancingPackageById(res.typeId);
            if (foundPackage) {
                var simpleResources = getResourceInfoFromPackageTypeField(foundPackage, "resourceReward", IdPendingInventoryRewardType.Resource);
                var buildings = getResourceInfoFromPackageTypeField(foundPackage, "buildingReward", IdPendingInventoryRewardType.Building);
                var pictures = getResourceInfoFromPackageTypeField(foundPackage, "pictureReward", IdPendingInventoryRewardType.Picture);
                return accumulator.concat(simpleResources, buildings, pictures);
            }
        }
        return accumulator;
    }, []);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPendingInventoryInfo.ts
// module id = 588
// module chunks = 3